import { DynamicFormV2Palette } from "@mui/material";

export type FormSelectFieldComponentTokenType = {
  textColor: string;
  placeholderColor: string;
  backgroundColor: string;
  borderColor: string;
  hoverBorderColor: string;
  errorBorderColor: string;
  popoverBackgroundColor: string;
  itemTextColor: string;
  selectedItemTextColor: string;
  selectedItemBackgroundColor: string;
  itemHoverBackgroundColor: string;
};

export const assignSelectFieldComponentTokens = (
  formsPalette: DynamicFormV2Palette["forms"],
  mode: "light" | "dark",
  isDullMode: boolean
) => {
  const isLightMode = mode === "light";

  return {
    textColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    placeholderColor: formsPalette.text.supershy,
    backgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    borderColor: isLightMode ? formsPalette.border.moderate : formsPalette.border.intense,
    hoverBorderColor: formsPalette.border.brand,
    errorBorderColor: formsPalette.border.error,
    popoverBackgroundColor: isLightMode ? formsPalette.surface.reverse : formsPalette.surface.supershy,
    itemTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.intense,
    selectedItemBackgroundColor: isLightMode
      ? isDullMode
        ? formsPalette.surface.moderate
        : formsPalette.surface.quiet
      : formsPalette.surface.reverse,
    selectedItemTextColor: isLightMode ? formsPalette.text.moderate : formsPalette.text.reverse,
    itemHoverBackgroundColor: isLightMode
      ? isDullMode
        ? formsPalette.surface.quiet
        : formsPalette.surface.supershy
      : formsPalette.surface.quiet,
  } as FormSelectFieldComponentTokenType;
};
